import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {ASSESSMENTIFRAME_URL_WITHOUT_PARAM, GAMEIFRAME_URL_WITHOUT_PARAM, INTERVIEWIFRAME_URL_WITHOUT_PARAM} from "../../Utils/Constants";
import {Col, Container, Modal, Row} from "react-bootstrap";
import t from "../../Utils/Translation";
import {Box} from "@mui/material";
import LykioButton from "../common/LykioButton";
import RightFooter from "../common/RightFooter";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import Button from "@mui/material/Button";
import {styled} from "@mui/material/styles";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";

const LykioPostStoryButtonInterview = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #0051b4, #00b1d1)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "rgb(0 118 190)",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "rgb(0 118 190)"
    },
}));

const LykioPostStoryButtonQuiz = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #9741b4, #e49ffc)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "#9741b4",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#9741b4"
    },
}));

const LykioPostStoryButtonAssessment = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #006f4b, #006f4b)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "#006f4b",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#006f4b"
    },
}));

const IframeIntro = () => {

    let location = useLocation();
    let url = location.pathname;
    let type = url.split('/')[1];
    const navigate = useNavigate();

    const typeInterview = 'interviewgame';
    const typeGame = 'activity';
    const typeAssessment = 'assessment';
    const {id} = useParams();
    console.log("====>"+id);


    const title = id==1 ? "Assess the availability for business trips and relocation" : 
                id==2 ? "Address the theme of disability" : 
                id==3 ? "Practice inclusive language" : 
                id==4 ? "Navigate the topic of gender identity" : 
                id==5 ? "Explore the topic of work-life balance" : 
                id==6 ? "Identify the questions to avoid" : 
                id==7 ? "Share the guidelines of the corporate dresscode" : 
                "Not Available"

    const description = id==1 ? "In this scenario you will meet Laura. Check in the job announcement position for which Laura is applying, analyze the candidate’s CV, talk with her while choosing the most appropriate questions to be asked. The goal consists in  understanding to what extent Laura is available to travel and transfer." : 
                id==2 ? "You are conducting an interview with a lawyer specializing in environmental law for a position at your company. The candidate's resume is highly impressive both in terms of acquired academic qualifications and professional experiences and skills. The point regarding their disability and how to ensure their effective integration into the workplace remains to be explored." : 
                id==3 ? "You are interviewing a candidate for an IT technician position. The candidate appears to have good experience and strong motivation. During the interview, the topic of dyslexia comes up. Explore this aspect with the aim of evaluating whether the candidate is suitable for the position, while using inclusive language and being sensitive to the matter." : 
                id==4 ? "During this selection interview, you will be interviewing a person who identifies as transgender. Please conduct the interview using inclusive language." : 
                id==5 ? "You are interviewing a candidate for an Expert Mechanical Maintenance position. During the interview, it comes to light that the candidate is a single father with two young children. Do you think this could affect his performance? How would you further explore this topic?" : 
                id==6 ? "You are assisting a colleague in further exploring the profile of a potential candidate, focusing particularly on reliability, confidentiality, and managerial abilities. You will be presented with various questions that you can ask: read them carefully and select those that you consider discriminatory to remove them from the list. At the end of the activity, you will receive feedback based on the choices you made." : 
                id==7 ? "You are interviewing a candidate for the position of 'Field Sales Account Condomini' for the Northwest region. The role requires managing business relationships with property managers, architecture designers, and construction firms. The candidate you are interviewing has an excellent CV. Now is the time to delve into their skills to determine if they are the right fit for this position." : 
                "Not Available"


    const gameIFrameUrl = `${GAMEIFRAME_URL_WITHOUT_PARAM}` + id;
    const interviewIFrameUrl = `${INTERVIEWIFRAME_URL_WITHOUT_PARAM}` + id;
    const assessmentIFrameUrl = `${ASSESSMENTIFRAME_URL_WITHOUT_PARAM}` + id;

    useEffect(() => {
        // if (type === typeGame){
        //     navigate(gameIFrameUrl);
        // }
    },[])

    const [modal, setModal] = useState(null);
    const handleOpen = (id) => {
        setModal(id);
    };

    const handleClose = () => {
        setModal(null);
    };

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance

    const annuncioImgUrl ='https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio_IRC218155_Prof.AgriculturalDevelopments+(COLLOQUIO)+(trascinato).png'
    const annuncioPdfUrl= localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio_IRC218155_Prof.AgriculturalDevelopments+(COLLOQUIO)+(trascinato).pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_Job+announcement_IRC218155_AgriculturalDevelopments+(COLLOQUIO).pdf";
 
    const curriculumImgUrl = 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/CV+Gentili+Laura+(COLLOQUIO).png';
    const curriculumPdfUrl = localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/CV+Gentili+Laura+(COLLOQUIO)+(1).pdf' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/_CV+Gentili+Laura+COLLOQUIO.pdf";
    return (
        <>
            {
                type === typeInterview ? (
                    <>
                        <>
                            <div className="lykioccs-main-content lykiocss-colloquio">
                                <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
                                    <Container className="lykiocss-margin-top-1em">
                                        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                                            <div style={{background: "linear-gradient(to bottom, #0051b4, #00b1d1)", color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'30em'}} className="lykiocss-center text-center">
                                                {t(title)}
                                            </div>
                                        </Row>
                                        <Row className="lykiocss-center" style={{background: "linear-gradient(to bottom, #0051b4, #00b1d1)", borderRadius:'0.5em', paddingBottom:'3em', paddingTop:'3em'}}>
                                            <Col xs={id == 1 ? 6 : 12}>
                                                <Box
                                                    color="white"
                                                    borderRadius={3}
                                                    p={3}
                                                    m={2}
                                                    textAlign={'center'}
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    style={{maxWidth: id == 1 ? '50em' : '80em'}}
                                                >
                                                    <p style={{fontSize:'21px'}}>{
                                                    
                                                    t(description)
                                                    
                                                    }</p>

                                                </Box>
                                            </Col>
                                            {id==1 && <Col className="d-flex justify-content-center">
                                                <div className={'text-center'} style={{border: '0px solid #0b6190', cursor: 'pointer'}} onClick={() => handleOpen(1)}>
                                                    <p >{t('Job announcement')}</p>
                                                    <img src={annuncioImgUrl} alt="image1" className="img-fluid" style={{width:'60%'}}/>
                                                </div>
                                                <div style={{border: '0px solid #0b6190', cursor: 'pointer'}} onClick={() => handleOpen(2)}>
                                                    <p style={{marginLeft:'1.5em'}}>{t('Curriculum Vitae')}</p>
                                                    <img src={curriculumImgUrl} alt="image2" className="img-fluid" style={{width:'60%'}}/>
                                                </div>
                                            </Col>}
                                        </Row>
                                    </Container>
                                </div>
                                <Row>
                                    <div className="lykiocss-center">
                                        <LykioPostStoryButtonInterview onClick={() => navigate(interviewIFrameUrl)} style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}}  className="lykiocss-margin-top-2em" >{t('Start')}</LykioPostStoryButtonInterview>
                                    </div>
                                </Row>
                                <RightFooter />
                            </div>

                        </>;
                    </>

                ) : type === typeAssessment ? (
                    <div className="lykioccs-main-content lykiocss-Valutazione">
                        <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
                            <Container className="lykiocss-margin-top-1em">
                                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                                    <div style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: 'white', padding: '1em', fontSize:'24px', borderRadius:'0.3em', maxWidth:'30em'}} className="lykiocss-center text-center">
                                        {id==1 ? t('EVALUATE THREE CANDIDATES BASED ON THEIR PRESENTATIONS AND CV') : 
                                        id==2 ? t('Experience the Blind Screening methodology') : 
                                        id==3 ? t("Identify the recruiter's biases") : 
                                        id==4 ? t("Assess the recruiter's performance") : 
                                        id==5 ? t("Deepen the Blind Screening Methodology") : 
                                        id==6 ? t("Select the best cv") : 
                                        id==7 ? t("Analyze the recruiter's language") : 
                                        ''}
                                    </div>
                                </Row>
                                <Row className="lykiocss-center" style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", borderRadius:'0.5em'}}>

                                        <Box
                                            color="white"
                                            borderRadius={3}
                                            m={2}
                                            textAlign={'center'}
                                            justifyContent="center"
                                            alignItems="center"
                                            style={{maxWidth:'50em'}}
                                        >
                                            <p style={{fontSize:'21px'}}>
                                            {id==1 ? t('During this quiz, you will be presented with 10 questions on topics related to unconscious cognitive biases. Your goal is to keep the rocket flying while reaching the end-line thus keep an eye on the fuel level! Time is ticking and the fuel is consumed quickly. Read the questions carefully and select the most appropriate answer. For every wrong answer, the rocket will lose one of the three available engines. After three errors, your journey will be interrupted, and you will have to start over. Increase your knowledge about biases and try to reach your final destination!') : 
                                            id==2 ? t("You are participating in a selection process for a geologist position using the blind screening methodology. Carefully read the announcement and choose which of the two candidates you believe is more suitable for the position based on the two \"blinded\" resumes.") : 
                                            id==3 ? t("In this evaluation activity, you will attend a brief interview between a recruiter and a potential candidate. Observe and listen carefully to the recruiter's expressions and words, and try to understand if their attitude is influenced by any biases, selecting those that you think you recognize.") :
                                            id==4 ? t("In this evaluation activity, you will witness a brief interview between a recruiter and a potential candidate. Evaluate the recruiter's performance by observing and listening carefully to the recruiter's expressions and words, and try to understand which biases are influencing their attitude.") :
                                            id==5 ? t("You are participating in a selection process for a corporate lawyer role using the blind screening methodology. Carefully read the announcement and choose which of the two candidates you believe is more suitable for the position based on the two \"blinded\" resumes.") :
                                            id==6 ? t("You are participating in the selection process for a Quality Control Professional in the Food Area who will be responsible for supporting all activities related to the management and development of product and service commercialization within Eni Live Stations in designated geographical areas. Below you will find an excerpt from the four resumes that have passed the initial selection. You can only invite one candidate. Please choose as quickly as possible which of the four candidates to invite.") :
                                            id==7 ? t("In this evaluation activity, you will observe a brief interview between a recruiter and a potential candidate for the position of Store Operations Manager. Assess the effectiveness and appropriateness of the questions posed by the recruiter to explore the candidate's leadership competencies.") 
                                            : ''}
                                            </p>
                                        </Box>


                                </Row>
                            </Container>
                        </div>
                        <Row>
                            <div className="lykiocss-center">
                                <LykioPostStoryButtonAssessment onClick={() => navigate(assessmentIFrameUrl)} style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}}  className="lykiocss-margin-top-2em" >{t('Start')}</LykioPostStoryButtonAssessment>
                            </div>
                        </Row>
                        <RightFooter />
                    </div>
                ) : (

                    <div className="lykioccs-main-content lykiocss-Quiz">
                        <div className="lykiocss-margin-top-4em" style={{display:'flex', justifyContent: 'center'}}>
                            <Container className="lykiocss-margin-top-1em">
                                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                                    <div style={{background: "linear-gradient(to bottom, #9741b4, #e49ffc)", color: 'white', padding: '1em', fontSize:'24px', borderRadius:'0.3em', maxWidth:'30em'}} className="lykiocss-center text-center">
                                        {id==1 ? t('Quiz - Unconscious Cognitive Biases') : id==2 ? t('Practice identifying linguistic biases in your job postings') : id==3 ? t("What is Steve's profession?") : id==4 ? t('Quiz - Biased or unbiased?') : id==5 ? t('Quiz - Inclusive recruitment: how much do you know?') : id==6 ? t('Quiz - How much do biases impact the recruitment?') : ''}
                                    </div>
                                </Row>
                                <Row className="lykiocss-center" style={{background: "linear-gradient(to bottom, #9741b4, #e49ffc)", borderRadius:'0.5em'}}>

                                        <Box
                                            color="white"
                                            borderRadius={3}
                                            m={2}
                                            textAlign={'center'}
                                            justifyContent="center"
                                            alignItems="center"
                                            style={{maxWidth:'50em'}}
                                        >
                                            <p style={{fontSize:'21px'}}>
                                            {id==1 ? t('During this quiz, you will be presented with 10 questions on topics related to unconscious cognitive biases. Your goal is to keep the rocket flying while reaching the end-line thus keep an eye on the fuel level! Time is ticking and the fuel is consumed quickly. Read the questions carefully and select the most appropriate answer. For every wrong answer, the rocket will lose one of the three available engines. After three errors, your journey will be interrupted, and you will have to start over. Increase your knowledge about biases and try to reach your final destination!') : 
                                            id==2 ? t('Identify the hidden biases within this job advertisement. Pay attention to the language used.') : 
                                            id==3 ? t('Challenge your ability to guess Steve\'s profession based on the description given by his neighbor.') :
                                            id==4 ? t('During a selection interview, it is important to avoid making statements that can be interpreted as discriminatory, even if there is no intention to discriminate. Identify the answers among the following phrases that may be biased because they refer to the personal sphere and not to the skills and experiences of the person.') :
                                            id==5 ? t('Which of the following statements are true? Your goal is to keep the rocket in flight, time is running out, and fuel is consumed quickly. For each wrong answer, the rocket will lose one of the three engines available. After three mistakes, your journey will be interrupted, and you will have to start over from the beginning.') :
                                            id==6 ? t('Test your knowledge about the influence of biases in the selection process. Read the following statements and determine whether they are true or false.') 
                                            : ''}
                                            </p>
                                        </Box>


                                </Row>
                            </Container>
                        </div>
                        <Row>
                            <div className="lykiocss-center">
                                <LykioPostStoryButtonQuiz onClick={() => navigate(gameIFrameUrl)} style={{ fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}}  className="lykiocss-margin-top-2em" >{t('Start')}</LykioPostStoryButtonQuiz>
                            </div>
                        </Row>
                        <RightFooter />
                    </div>
                )
            }


            {modal === 1 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Job announcement")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={annuncioPdfUrl} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
            {modal === 2 && (
                <Modal show={true} onHide={handleClose} size='xl' >
                    <Modal.Header closeButton>
                        <Modal.Title>{t('Curriculum Vitae')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Box height={'70vh'} position={'relative'}>
                            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                                <div   style={{
                                    height: '100%',
                                    width: '100%'
                                }}>
                                    <Viewer fileUrl={curriculumPdfUrl} plugins={[defaultLayoutPluginInstance]} />;
                                </div>
                            </Worker>
                        </Box>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            {t("Close")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            )}
        </>

    )


}

export default IframeIntro